/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function FilterIcon(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
            viewBox='0 0 34 26'
        >
            <svg
                height='26px'
                version='1.1'
                viewBox='0 0 34 26'
                width='34px'
                xmlns='http://www.w3.org/2000/svg'
                xmlnsXlink='http://www.w3.org/1999/xlink'
            >
                <title>filter</title>
                <g
                    fill={iconColor || 'none'}
                    fillRule='evenodd'
                    id='The-Network-'
                    stroke='none'
                    strokeWidth='1'
                >
                    <g
                        id='Admin-Dash'
                        transform='translate(-269.000000, -127.000000)'
                    >
                        <g
                            id='filter'
                            transform='translate(270.000000, 128.000000)'
                        >
                            <path
                                d='M13.2093725,16.3051274 L18.7670192,16.3051274 C19.2300398,16.3051274 19.2300398,17 18.7670192,17 L13.2093725,17 C12.746352,17 12.746352,16.3051274 13.2093725,16.3051274 Z M10.431216,12.1372258 L21.5451757,12.1372258 C22.0081962,12.1372258 22.0081962,12.8320984 21.5451757,12.8320984 L10.431216,12.8320984 C9.9681955,12.8320984 9.9681955,12.1372258 10.431216,12.1372258 Z M8.34726539,8 L23.6291265,8 C24.092147,8 24.092147,8.69422236 23.6291265,8.69422236 L8.34726539,8.69422236 C7.88424487,8.69422236 7.88424487,8 8.34726539,8 Z'
                                fill='#000000'
                                id='Fill-1'
                            />
                        </g>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}